<template>
  <div class="solveView">
    <div class="title">
      <img src="./img/titleMd.png" alt="">
    </div>
    <!-- 内容 -->
    <div class="solveBox" v-for="item in solveTitle" :key="item.ID">
      <p class="solveTitle">{{item.Name}}</p>
      <!-- 解决方案列表组件 -->
      <md-solve-title :solve-id= item.ID />
      <!-- <div class="solveContent">
        <div class="solveContentItem"  v-for="i in 3" :key="i">
          <p class="solveContentImg"><img src="./img/itemMd.png" alt=""></p>
          <p class="solveContentTitle">医药批发</p>
          <p class="solveContentDetail">根据品种特性确保不同订单同步性策略</p>
        </div>
      </div> -->
    </div>
    <!-- 没有数据 -->
            <div class="noContent" v-show="solveTitle.length===0">
              <img src="~@/assets/img/noContent.png" alt="">
          </div>
  </div>
</template>

<script>
import MdSolveTitle from './components/solveList/MdSolveTitle.vue'
export default {
  components: { MdSolveTitle },
  computed: {
    solveTitle () {
      return this.$store.state.solveTitle
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.noContent{
  width: 750px/$md;
  display: flex;
  justify-content: center;
  img{
    width: 70%;
  }
}
.solveView{
  width: 100%;
  .title{
    width: 750px/$md;
    height: 300px/$md;
margin-bottom: 40px/$md;
    img{
      width: 100%;
    }
  }
}
.solveBox{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
margin-bottom: 40px/$md;
  // 标题
  .solveTitle{
width: 690px/$md;
height: 53px/$md;
font-size: 26px/$md;
font-weight: 700;
color: #333333;
  border-bottom: 1px/$md solid #E6E6E6;
  }

}
</style>
